export const CONFIGURED_FEATURES = {
  SSR: 'SSR',
  CCBAT: 'CCBAT',
  AUTO_APPLY_ACCESSORIAL: 'AUTO_APPLY_ACCESSORIAL',
  CARRIER_MANDATORY_STOP_DOCUMENTS: 'CARRIER_MANDATORY_STOP_DOCUMENTS',
  AMAZON_PRE_ARRIVAL: 'AMAZON_PRE_ARRIVAL',
  MARKET_EXCEPTIONS: 'MARKET_EXCEPTIONS',
  BULK_MARKET_EXCEPTIONS: 'BULK_MARKET_EXCEPTIONS',
  ENABLE_MULTIPLE_HAZMAT_DETAILS: 'ENABLE_MULTIPLE_HAZMAT_DETAILS',
};

export const FEATURE_FLAGS = {
  SSR: ENABLE_SSR,
  CCBAT: ENABLE_CCBAT,
  AUTO_APPLY_ACCESSORIAL: ENABLE_AUTO_APPLY_ACCESSORIAL,
  CARRIER_MANDATORY_STOP_DOCUMENTS: ENABLE_CARRIER_MANDATORY_STOP_DOCUMENTS,
  AMAZON_PRE_ARRIVAL: ENABLE_AMAZON_PRE_ARRIVAL,
  MARKET_EXCEPTIONS: ENABLE_MARKET_EXCEPTIONS,
  BULK_MARKET_EXCEPTIONS: ENABLE_BULK_MARKET_EXCEPTIONS,
  ENABLE_MULTIPLE_HAZMAT_DETAILS: ENABLE_MULTIPLE_HAZMAT_DETAILS,
};

export const featureEnabled = (feature) => {
  if (!(feature && CONFIGURED_FEATURES[feature])) {
    console.log(
      `[featureEnabled] Feature flag configuration is invalid. Feature - ${feature}`,
    );
    return;
  }
  return FEATURE_FLAGS[feature] === true;
};
